import { createSelector } from 'reselect';
import _ from 'lodash';
import { initialState } from './reducer';

export const selectMessageDomain = (state) => state.message || initialState;

export const makeSelectMessage = () => createSelector(selectMessageDomain, _.property('message'));

export const makeSelectLoading = () => createSelector(selectMessageDomain, _.property('loading'));

export const makeSelectDefaultMessageRequest = () => createSelector(selectMessageDomain, _.property('defaultMessageRequest'));

export const makeSelectWebhook = () => createSelector(selectMessageDomain, _.property('webhook'));

export const makeSelectRequestNumber = () => createSelector(selectMessageDomain, _.property('requestNumber'));

export const makeSelectIsTestMode = () => createSelector(selectMessageDomain, _.property('isTestMode'));
